<script setup lang="ts">
import type { ICompany, IUserCompany } from '@types'
import SuperRemove from '@plf/components/modals/SuperRemove.vue'
import { PageNames } from '@plf/utils/PageNames'

const props = withDefaults(
  defineProps<{
    page?: PageNames
    company?: ICompany
    companies?: IUserCompany[]
    allowCompanyPage?: boolean
    allowUnlink?: boolean
    allowLink?: boolean
    allowCreate?: boolean
    userId?: number
  }>(),
  {
    company: () => ({}) as ICompany,
    companies: () => [],
    allowCompanyPage: false,
    allowCreate: true,
    allowUnlink: false,
    allowLink: false,
  },
)

const emit = defineEmits<{
  close: []
  unlink: []
  link: []
}>()

const route = useRoute()

const companyList = computed(() =>
  props.companies.map(c => ({
    id: c.id,
    name: c.clientName,
    company: c,
  })),
)

function getUrl(c: { id: number }) {
  if (props.page) {
    const page = !props.allowCompanyPage && props.page === PageNames.Company ? PageNames.Services : props.page
    return { name: page, params: { id: c.id } }
  }

  if (route.name === PageNames.Profile) {
    return { query: { companyId: c.id } }
  }

  return { params: { id: c.id } }
}

function close() {
  emit('close')
}
</script>

<template lang="pug">
UiList
  template(v-for="c of companyList" :key="c.id")
    NuxtLink.text-none(
      :to="getUrl(c)"
      @click="close"
    )
      UiListItem(
        flag
        :label="c.name"
        :modelValue="company.id"
        :value="c.company.id"
      )
        template(v-if="allowUnlink" #right)
          SuperRemove(:userId="userId" :clientId="c.id" @delete="$emit('unlink')")

  template(v-if="allowCreate || allowLink")
    UiListItem(variant="divider")

    NuxtLink.text-none(v-if="allowCreate" :to="{ name: PageNames.Company, params: { id: 'create' } }" @click="close")
      UiListItem(label="layout.header.add_company" variant="button")

    UiListItem(v-if="allowLink" label="Прикрепить компанию" variant="button" @click="$emit('link')")
</template>
